var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.25a.75.75 0 0 1 .648.373l1.774 3.044 3.443.746a.75.75 0 0 1 .4 1.233l-2.347 2.627.355 3.506a.75.75 0 0 1-1.048.761L8 12.12l-3.224 1.42a.75.75 0 0 1-1.049-.761l.355-3.506-2.347-2.627a.75.75 0 0 1 .4-1.233l3.444-.746 1.773-3.044A.75.75 0 0 1 8 1.25zm0 2.24L6.71 5.708a.75.75 0 0 1-.49.355l-2.508.543 1.71 1.914a.75.75 0 0 1 .187.575l-.259 2.553 2.349-1.034a.75.75 0 0 1 .605 0l2.348 1.034-.258-2.553a.75.75 0 0 1 .186-.575l1.71-1.914-2.508-.543a.75.75 0 0 1-.49-.355L8.002 3.49z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;